// extracted by mini-css-extract-plugin
module.exports = {"add":"add__gm0mL","icon":"icon__16UYI"};